import Vue from "vue"
import VueRouter, { RouteConfig } from "vue-router"
import AjoneuvoverolaskuriPage from "../views/AjoneuvoverolaskuriPage.vue"
import VAKHakuPage from "../views/VAKHakuPage.vue"
import VAKSubstancePage from "../views/VAKSubstancePage.vue"
import LKPKannattavuuslaskuriPage from "../views/LKPKannattavuuslaskuriPage.vue"

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: "/Ajoneuvoverolaskuri",
        name: "Ajoneuvoverolaskuri",
        component: AjoneuvoverolaskuriPage,
        props: true
    },
    {
        path: "/VAKHaku",
        name: "VAKHaku",
        component: VAKHakuPage
    },
    {
        path: "/VAKAine/:ykNro",
        name: "VAKAine",
        component: VAKSubstancePage,
        props: true
    },
    {
        path: "/LKPKannattavuuslaskuri",
        name: "LKPKannattavuuslaskuri",
        component: LKPKannattavuuslaskuriPage
    }
]

const router = new VueRouter({
  mode: "history",
    base: process.env.BASE_URL + "AutoilijanPalvelut/",
  routes
})

export default router
